import { connect } from "react-redux";

import { post } from "../../../../../../../actions/general";
import { editTask } from "../../../../../../../store/plan/actions";

import Bars from "./Bars";

export default connect(null, { post, editTask })(Bars);
